module.exports = __webpack_public_path__ + "img/GreenMarker.a45a40e6.svg";